import React, { Component } from 'react'

import { Card } from 'antd'

function shuffle(array) {
  let currentIndex = array.length,
    temporaryValue,
    randomIndex

  // While there remain elements to shuffle...
  while (0 !== currentIndex) {
    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex)
    currentIndex -= 1

    // And swap it with the current element.
    temporaryValue = array[currentIndex]
    array[currentIndex] = array[randomIndex]
    array[randomIndex] = temporaryValue
  }

  return array
}
interface OfferListState {
  data: []
}

class OfferList extends Component<unknown, OfferListState> {
  constructor(props: unknown) {
    super(props)

    this.state = {
      data: [],
    }
  }

  componentDidMount() {
    fetch('/offers.json')
      .then((response) => response.json())
      .then((data) => this.setState({ data: data.data }))
  }

  render() {
    return (
      <>
        {shuffle(this.state.data).map(function (offer: any, idx) {
          return (
            <Card
              key={idx}
              onClick={() => window.open(`${offer.link}`, '_blank')}
              hoverable
              title={offer.partner}
              extra={
                <a target="_partner" href={offer.link}>
                  View...
                </a>
              }
              style={{ marginBottom: 20 }}
            >
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div style={{ marginRight: 10 }}>
                  <img
                    src={
                      offer.image_url ||
                      'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8Xw8AAoMBgDTD2qgAAAAASUVORK5CYII='
                    }
                    style={{ width: 100, height: 100, border: 'solid 1px #ccc' }}
                  />
                </div>
                <div>
                  <div>
                    <strong>{offer.title}</strong>
                  </div>
                  <div>{offer.description}</div>
                </div>
              </div>
            </Card>
          )
        })}
      </>
    )
  }
}

export const WhatsNewView = () => (
  <>
    <h3 style={{ marginBottom: 20 }}>Partner Offers</h3>

    <OfferList />
  </>
)
